import React from 'react';
import { Context } from '../../App';
import Product, { ProductModel } from '../../model/product';
import ModelInput from '../../base-components/ModelInput';
import Card from '../../base-components/Card';
import useModel from '../../base-components/hooks/useModel';
import EditorParent from '@/base-components/EditorParent';
import { deleteProduct } from '@/api/product-controller';
import { useNavigate } from 'react-router-dom';
import { RoutePath, SPACING } from '@/generic/config';
import { Box } from '@chakra-ui/react';
import Text from '@/base-components/Text';
import ProductIconPicker from '@/base-components/ProductIconPicker';

const ProductPage: React.FC = () => {
    const { translations } = React.useContext(Context);
    const { model, toolbar } = useModel<Product>(ProductModel);
    const navigate = useNavigate();
    const iconDirty = (model.object.taskIcon ?? "") !== (model.initialObject.taskIcon ?? "");

    const title = model.isNew
        ? translations.systemSettings.product.create
        : `${translations.model.product.search.title} — ${model.object.code} (${model.object.id})`;

    const actions = model.isNew ? [] : [
        {
            title: translations.model.product.delete,
            onClick: async () => {
                await deleteProduct(model.object);
                navigate(RoutePath.Products);
            },
        },
    ];

    return (
        <EditorParent title={title} toolbar={toolbar} actions={actions}>
            <Card title={translations.model.product.code} description={translations.systemSettings.product.description}>
                <ModelInput title={translations.model.product.code} fieldKey="code" model={model} />
                <ModelInput title={translations.common.active} fieldKey="enabled" model={model} />
                <Box m={SPACING / 4} textAlign="start">
                    <Text weight={iconDirty ? "bolder" : "semibold"} mb={SPACING / 2}>
                        {translations.model.product.taskIcon}{iconDirty ? "*" : ""}
                    </Text>
                    <ProductIconPicker
                        value={model.object.taskIcon}
                        onChange={(name) => model.setObject(prev => prev ? { ...prev, taskIcon: name ?? "" } : prev)}
                    />
                </Box>
            </Card>
            <Card title={translations.model.product.tasksCard.title} description={translations.model.product.tasksCard.description}>
                <ModelInput title={translations.model.product.showOnTasks} fieldKey="showOnTasks" model={model} />
                <ModelInput title={translations.model.product.taskSort} fieldKey="taskSort" type="number" model={model} />
            </Card>
        </EditorParent>
    );
};

export default ProductPage;
